import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ConversationGridFiltersActions } from '../../../../../sic-lib/reducers/conversationGridFiltersReducer';
import { ConversationGridFiltersItem } from '../../../../../sic-lib/types/ConversationGridFiltersItem';
import { IErrorFormValidation } from '../../../../../sic-lib/utils/formValidationHelpers';
import ConversationGridFiltersListItem from '../ConversationGridFiltersListItem/ConversationGridFiltersListItem';

const useStyles = makeStyles()((theme: Theme) => ({}));

type Props = {
    filters: ConversationGridFiltersItem[];
    formDispatch: React.Dispatch<ConversationGridFiltersActions>;
    formError: IErrorFormValidation | null;
};

export default function ConversationGridFiltersList({ filters, formDispatch, formError }: Props) {
    const { classes } = useStyles();

    const scrollRef = React.useRef<HTMLDivElement | null>(null);
    const lengthRef = React.useRef<number>(0);

    React.useEffect(() => {
        if (lengthRef.current < filters.length) {
            /* scroll to the bottom of the filters list; only if a new filter has been added */
            scrollRef.current && scrollRef.current.scrollTo(0, scrollRef.current.scrollHeight);
        }

        lengthRef.current = filters.length;
    }, [filters.length]);

    return (
        <>
            {filters.map(itm => (
                <ConversationGridFiltersListItem
                    key={itm.fieldId}
                    config={itm}
                    formDispatch={formDispatch}
                    formError={formError}
                />
            ))}
        </>
    );
}
